import React from "react";
import "./CompanyProfile.css";
import Image from './bgimg.png';
import Fade from 'react-reveal/Fade';
import { Dimensions } from '../../Helper/sitedimension';

const CompanyProfileUI = () => {
  const { width } = Dimensions.useWindowDimensions();
  return (
    <div className="companyprofile">
      {width > 500 ?
        <div className="container-fluid prof-wr">
          <div className="row">
            <div className="col-6 pr-bg">
              <img className="profile-image" src={Image} alt="company profile " />
            </div>
            <div className="col-6 r-cn">
              <Fade delay={300}>
                <h2 className="prof-title">
                  <span className="our">Our </span> Company Profile
              </h2>
              </Fade>
              <p className="text-left desc">
                <Fade delay={500}>
                The demand of cyber security solutions along with the transformations in the latest technologies,
                 lead to the formation of Secure Blink. We are working towards building efficient AI-enabled
                  cyber security products that would help in predicting, analyzing, and reporting the major
                   issues in your systems.  There is a growing threat of cyber attacks and to tackle these
                    we are  continuously working towards building powerful tools that would ensure a safer
                     browsing environment. Secure Blink has a scanning mechanism which thoroughly scans 
                     and report the issues in your system. With this, you can also predict the possibility
                      of future attacks and take tight measures to avoid consequences.
              </Fade>
              </p>
            </div>
          </div>
        </div> :
        <div className="container-fluid prof-wrab">
          <div className="row">
            <div className="r-cnab">
              <Fade delay={300}>
                <h2 className="prof-titleab">
                  <span className="our">Our </span> Company Profile
                </h2>
              </Fade>
              <p className="text-left descab">
                <Fade delay={500}>
                The demand of cyber security solutions along with the transformations in the latest technologies,
                 lead to the formation of Secure Blink. We are working towards building efficient AI-enabled
                  cyber security products that would help in predicting, analyzing, and reporting the major
                   issues in your systems.  There is a growing threat of cyber attacks and to tackle these
                    we are  continuously working towards building powerful tools that would ensure a safer
                     browsing environment. Secure Blink has a scanning mechanism which thoroughly scans 
                     and report the issues in your system. With this, you can also predict the possibility
                      of future attacks and take tight measures to avoid consequences.
            </Fade>
              </p>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default CompanyProfileUI;
